(() => {
  const ROOT_SELECTOR = "[data-p4m-review-carousel]";

  function init(root) {
    if (!root || root.dataset.p4mReviewReady === "true") return;

    const viewport = root.querySelector("[data-p4m-review-viewport]");
    const slides = Array.from(root.querySelectorAll("[data-p4m-review-slide]"));
    const previous = root.querySelector("[data-p4m-review-prev]");
    const next = root.querySelector("[data-p4m-review-next]");
    const count = root.querySelector("[data-p4m-review-count]");
    const progress = root.querySelector("[data-p4m-review-progress]");
    if (!viewport || slides.length < 2 || !previous || !next) return;

    root.dataset.p4mReviewReady = "true";
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    let autoplayTimer = 0;
    let scrollTimer = 0;

    const maxScroll = () => Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    const slideStep = () => {
      if (slides.length < 2) return slides[0]?.getBoundingClientRect().width || viewport.clientWidth;
      return Math.max(1, slides[1].offsetLeft - slides[0].offsetLeft);
    };
    const currentIndex = () => Math.min(slides.length - 1, Math.max(0, Math.round(viewport.scrollLeft / slideStep())));
    const furthestIndex = () => Math.max(0, Math.round(maxScroll() / slideStep()));

    const update = () => {
      const index = currentIndex();
      if (count) count.textContent = `${index + 1} / ${slides.length}`;
      if (progress) progress.style.setProperty("--p4m-review-progress", `${((index + 1) / slides.length) * 100}%`);
    };

    const move = (direction) => {
      const limit = maxScroll();
      const step = slideStep();
      const index = currentIndex();
      const lastIndex = furthestIndex();
      let target;
      if (direction > 0) target = index >= lastIndex ? 0 : Math.min(limit, (index + 1) * step);
      else target = index <= 0 ? limit : Math.max(0, (index - 1) * step);
      viewport.scrollTo({ left: target, behavior: reducedMotion.matches ? "auto" : "smooth" });
    };

    const stopAutoplay = () => {
      window.clearInterval(autoplayTimer);
      autoplayTimer = 0;
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (root.dataset.autoplay !== "true" || reducedMotion.matches || document.hidden) return;
      const delay = Math.max(3500, Number(root.dataset.autoplayDelay) || 6500);
      autoplayTimer = window.setInterval(() => move(1), delay);
    };

    previous.addEventListener("click", () => {
      move(-1);
      startAutoplay();
    });
    next.addEventListener("click", () => {
      move(1);
      startAutoplay();
    });
    viewport.addEventListener("keydown", (event) => {
      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
      event.preventDefault();
      move(event.key === "ArrowRight" ? 1 : -1);
      startAutoplay();
    });
    viewport.addEventListener("scroll", () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(update, 90);
    }, { passive: true });
    root.addEventListener("mouseenter", stopAutoplay);
    root.addEventListener("mouseleave", startAutoplay);
    root.addEventListener("focusin", stopAutoplay);
    root.addEventListener("focusout", (event) => {
      if (!root.contains(event.relatedTarget)) startAutoplay();
    });
    root.addEventListener("pointerdown", stopAutoplay, { passive: true });
    root.addEventListener("pointerup", startAutoplay, { passive: true });
    document.addEventListener("visibilitychange", startAutoplay);
    reducedMotion.addEventListener?.("change", startAutoplay);
    window.addEventListener("resize", update, { passive: true });

    update();
    startAutoplay();
  }

  function initAll(scope = document) {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initAll());
  else initAll();

  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
})();

